import { connect, ConnectedProps } from 'react-redux';

import { setShowLeftMenu, setDarkMode, setSignedIn, setStateOfOperations } from '../state/actions';

import NavigationTopBar from '../components/NavigationTopBar';

interface RootState {
    showLeftMenu: boolean;
    darkMode: boolean;
    isConsideredMobile: boolean;
    signedIn: boolean;
}
  
const mapStateToProps = (state: RootState) => ({
    showLeftMenu: state.showLeftMenu,
    darkMode: state.darkMode,
    isConsideredMobile: state.isConsideredMobile,
    signedIn: state.signedIn,
})
  
const mapDispatchToProps = {
    setShowLeftMenu,
    setDarkMode,
    setSignedIn,
    setStateOfOperations,
}
  
const connector = connect(mapStateToProps, mapDispatchToProps)
  
export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(NavigationTopBar)